import type AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import { getOfflineSyncStatus } from 'mini-app-module-store/lib/selectors/getOfflineSyncStatus';

export const canShowOfflineSyncInProgress = () => {
    const canSync = getOfflineSyncStatus() === 7;

    return canSync;
};
